import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import moment from "moment";
import {
  getSuspicousCloudData,
  getSuspicousCloudAction,
  getSuspicousCloudTotal,
  getSuspicousCloudGraph
} from "../../actions/fakeMobileApp";
import "../../assets/css/details-slider.css";
import "../../assets/css/recommendation-modal.css";
import TrialComponent from "../common/trialComponent";
import NoData from "../common/noDataComponetnt";
import Pagination from "../Pagination/Pagination";
import BasicLineColumn from "../common/apexChart/lineChart";
import AccessPage from "../Shared/accessPage";
import axios from "axios";
import { API_URL } from "../../utils/constant";
import MenuItem from "@mui/material/MenuItem";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import $ from "jquery";
import { rescanSingle } from "../../actions/users";
import Microsoft from "../../assets/images/microsoft.png";
import google from "../../assets/images/google-svgrepo-com 1.png";
import aws from "../../assets/images/aws.png";
import cloud from "../../assets/images/cloud.png";
import { format } from "date-fns";
import DatePicker from "react-datepicker";

const sliderStyles = `
  body.details-slider-open {
    overflow: hidden;
  }
  
  .details-slider-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: 1040;
    opacity: 0;
    transition: opacity 0.3s ease;
    pointer-events: none;
  }
  
  .details-slider-overlay.show {
    opacity: 1;
    pointer-events: all;
  }
  
  .details-slider-panel {
    position: fixed;
    top: 0;
    right: -600px;
    width: 600px;
    max-width: 90vw;
    height: 100%;
    background: #ffffff;
    box-shadow: -4px 0 20px rgba(0, 0, 0, 0.3);
    z-index: 1050;
    transition: right 0.4s cubic-bezier(0.4, 0, 0.2, 1);
    overflow: hidden;
    display: flex;
    flex-direction: column;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }
  
  .details-slider-panel.open {
    right: 0;
  }
  
  .details-slider-content {
    background: #ffffff;
    height: 100%;
    min-height: 100%;
    max-height: 100%;
    padding: 0;
    margin: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    box-sizing: border-box;
  }
  
  .details-slider-header {
    background: #453acd;
    color: white;
    padding: 15px 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    flex-shrink: 0;
  }
  
  .details-slider-header h5 {
    margin: 0;
    font-size: 1.1rem;
    font-weight: 600;
  }
  
  .details-slider-close {
    background: rgba(255, 255, 255, 0.2);
    border: none;
    color: white;
    width: 30px;
    height: 30px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    font-size: 18px;
  }
  
  .details-slider-close:hover {
    background: rgba(255, 255, 255, 0.3);
  }
  
  .details-slider-body {
    padding: 20px;
    overflow-y: auto;
    flex: 1;
  }
  
  .details-section {
    background: #ffffff;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 15px;
    margin-bottom: 15px;
  }
  
  .details-section-title {
    font-size: 1rem;
    font-weight: 600;
    color: #212529;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    gap: 8px;
    padding-bottom: 10px;
    border-bottom: 1px solid #dee2e6;
  }
  
  .details-section-title i {
    color: #453acd;
    font-size: 1rem;
  }
  
  .details-info-item {
    display: flex;
    padding: 8px 0;
    border-bottom: 1px solid #f1f3f5;
  }
  
  .details-info-item:last-child {
    border-bottom: none;
  }
  
  .details-info-label {
    font-weight: 600;
    color: #495057;
    min-width: 140px;
    flex-shrink: 0;
    font-size: 0.9rem;
  }
  
  .details-info-value {
    color: #212529;
    flex: 1;
    word-break: break-word;
    font-size: 0.9rem;
  }
  
  .public-link-item {
    background: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 12px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: all 0.3s ease;
  }
  
  .public-link-item:hover {
    background: #e9ecef;
    border-color: #453acd;
  }
  
  .public-link-url {
    flex: 1;
    word-break: break-all;
    color: #453acd;
    font-family: monospace;
    font-size: 0.85rem;
    margin-right: 10px;
  }
  
  .public-link-button {
    background: #453acd;
    color: white;
    border: none;
    padding: 6px 12px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 0.85rem;
    transition: all 0.3s ease;
    white-space: nowrap;
  }
  
  .public-link-button:hover {
    background: #3829b8;
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  }
  
  @media (max-width: 768px) {
    .details-slider-panel {
      width: 100vw;
      right: -100vw;
    }
  }
`;

const SourceCodeLeakage = () => {
  const { orgId } = useParams();
  const id = useSelector(state => {
    if (orgId) {
      return orgId;
    } else {
      return state?.summary?.localClient?._id || state?.summary?.clients?.[0]?._id;
    }
  });
  const userPermission = useSelector(state => {
    return state?.auth?.user?.modulePermissionsConfig?.de?.e;
  });
  const auth = useSelector((state) => state?.auth?.user);
  const myRef = useRef(null);
  const iframeLoadTimeoutRef = useRef(null);
  const [page, setPage] = useState(1);
  const [filterData, setfilterData] = useState("all");
  const [fileType, setFileType] = useState("all");
  const [category, setCategory] = useState("all");
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [totalItems, setTotalItems] = useState(0);
  const [isModal, setModal] = useState("");
  const [forValue, setForValue] = useState("forever");
  const [lookalikeAppId, setLookalikeAppId] = useState([]);
  const [actionNote, setActionNote] = useState("");
  const [search, setSearch] = useState("");
  const [action, setAction] = useState("");
  const [selectedValue, setSelectedValue] = useState("pleaseSelect");
  const [keyword, setKeyword] = useState('all');
  const vendorName = sessionStorage.getItem('vendorName');
  const vendorId = sessionStorage.getItem('vendorId');
  const [limit, setLimit] = useState(10);
  const client = useSelector(
    (state) => state?.summary?.localClient || state?.summary?.clients?.[0]
  );

  // Extract keywords from client data
  const clientKeywords = client?.keyWord || [];

  const dispatch = useDispatch();

  const state = useSelector(
    (state) => state?.openCloud?.suspicious?.data?.data
  );
  const totalResponse = useSelector(
    (state) => state?.openCloud?.cloudbuckettotal?.data
  );
  const totalCount = useSelector(
    (state) => state?.openCloud?.suspicious?.data?.totalProfiles
  );
  let oldDnsDetails = useSelector(
    (state) => state.openCloud?.cloudbucketgraph?.data
  );

  let ipArray = [];
  for (
    let details = 0;
    details < oldDnsDetails?.scanDetails?.length;
    details++
  ) {
    ipArray.push(oldDnsDetails?.scanDetails[details]);
  }

  // Add these state variables to handle the date objects
  const [startDateObj, setStartDateObj] = useState(null);
  const [endDateObj, setEndDateObj] = useState(null);

  // Update startDateObj and endDateObj whenever startDate or endDate change
  useEffect(() => {
    if (startDate) {
      setStartDateObj(new Date(startDate));
    }
    if (endDate) {
      setEndDateObj(new Date(endDate));
    }
  }, [startDate, endDate]);

  useEffect(() => {
    getSuspicousCloudData(id, dispatch, page, category, filterData, startDate, endDate, limit, search, keyword, fileType);
  }, [id, dispatch, page, category, filterData, startDate, endDate, limit, search, keyword, fileType]);

  useEffect(() => {
    setTotalItems(totalCount);
  }, [totalCount]);

  useEffect(() => {
    getSuspicousCloudTotal(id, dispatch);
  }, [id, dispatch]);

  useEffect(() => {
    getSuspicousCloudGraph(id, dispatch);
  }, [id, dispatch]);

  const addModal = () => {
    setModal("Form Wizard modal");
  };

  const clearFliter = () => {
    setfilterData("all");
    setFileType("all");
    setPage(1);
    setSearch("");
    setSelectedIds([]);
    setKeyword("all");
  }

  const clearFliterNotFilters = () => {
    setPage(1);
    setSelectedIds([]);
  }

  const [selectedIds, setSelectedIds] = useState([]);
  const [multiCheckTrue, setMultiCheckTrue] = useState(false);

  const multicheck = (data) => {
    const allIds = data?.map((item) => item._id);
    if (selectedIds.length > 0 || selectedIds.length == 0) {
      setMultiCheckTrue(true);
      setSelectedIds(allIds);
    }
    if (multiCheckTrue == true) {
      setSelectedIds([]);
      setMultiCheckTrue(false);
    }
  };

  const singleClick = (id, data) => {
    setSelectedIds((prevSelectedIds) => {
      if (prevSelectedIds.includes(id)) {
        return prevSelectedIds.filter((selectedId) => selectedId !== id);
      } else {
        return [...prevSelectedIds, id];
      }
    });
    if (selectedIds.length > 10) {
      setMultiCheckTrue(true);
    } else {
      setMultiCheckTrue(false);
    }
  };

  const snooze = (_id, event) => {
    if (event === "markAsRemidiated") {
      $.confirm({
        title: "Are you sure?",
        content: "Do you really want to mark this as remediated?",
        type: "green",
        buttons: {
          ok: {
            text: "Yes, Mark as Remediated",
            btnClass: "btn-success",
            keys: ["enter"],
            action: function () {
              let ids = [];
              ids.push(_id);
              const data = {
                action: "markAsRemediated",
                cloudBucketDetailIds: selectedIds.length === 0 ? ids : selectedIds,
                actionNote: "",
                for: "forever",
              };
              getSuspicousCloudAction(id, dispatch, 1, category, filterData, data, limit, startDate, endDate, search, keyword, fileType);
              setSelectedValue("pleaseSelect");
              setActionNote("");
              clearFliterNotFilters();
            },
          },
          cancel: function () {
          },
        },
      });
    }
  };

  const Unsnoozed = (_id) => {
    let ids = [];
    ids.push(_id);
    const data = {
      action: 'resetAction',
      cloudBucketDetailIds: selectedIds == 0 ? ids : selectedIds,
    };
    getSuspicousCloudAction(id, dispatch, 1, category, filterData, data, limit, startDate, endDate, search, keyword, fileType);
    clearFliterNotFilters();
  }

  const submit = () => {
    const data = {
      action: action,
      cloudBucketDetailIds: selectedIds == 0 ? lookalikeAppId : selectedIds,
      actionNote: actionNote,
      for: forValue,
    };
    getSuspicousCloudAction(id, dispatch, 1, category, filterData, data, limit, startDate, endDate, search, keyword, fileType);
    setModal("");
    setSelectedValue("pleaseSelect");
    setActionNote("");
    clearFliterNotFilters();
  };

  const executeScroll = (val) => {
    setfilterData(val);
    myRef.current.scrollIntoView(); // run this function from an event handler or pass it to useEffect to execute scroll
  };

  let clientName = "";

  if (JSON.parse(localStorage.getItem("OrgName"))) {
    if (sessionStorage.getItem('vendorId')) {
      clientName = sessionStorage.getItem('vendorName')
    } else {
      clientName = JSON.parse(localStorage.getItem("OrgName"));
    }
  }

  const downloadFile = async () => {
    try {
      const session = localStorage.getItem("session");
      axios.defaults.headers.common["Authorization"] = `Bearer ${session}`;
      const response = await axios.get(
        `${API_URL}/cloud-bucket-details/${id}/excel`,
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `${clientName?.replace(/\s+/g, '-')}Open Cloud Buckets.xlsx`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      // console.error removed
    }
  };

  let currentTableData = [];

  let mapData = state;

  if (mapData && mapData.length > 0) {
    currentTableData = mapData;
  }

  const reScan = () => {
    let data = {
      "moduleName": ["openCloudBucket"]
    }
    rescanSingle(id, data)
  }

  const [detailsModal, setDetailsModal] = useState(false);
  const [selectedRowDetails, setSelectedRowDetails] = useState(null);
  const [bucketFiles, setBucketFiles] = useState([]);
  const [selectedFileUrl, setSelectedFileUrl] = useState(null);
  const [iframeLoading, setIframeLoading] = useState(true);
  const [iframeError, setIframeError] = useState(false);


  // Handle opening external URLs
  const handleOpenUrl = (url) => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
    }
  };

  // Set bucket files when details modal opens
  useEffect(() => {
    if (detailsModal && selectedRowDetails) {
      // Use files from selectedRowDetails if available
      if (selectedRowDetails.files && Array.isArray(selectedRowDetails.files)) {
        setBucketFiles(selectedRowDetails.files);
      } else {
        setBucketFiles([]);
      }
      // Auto-preview the URL if available
      if (selectedRowDetails.url) {
        setSelectedFileUrl(selectedRowDetails.url);
        setIframeLoading(true);
        setIframeError(false);
      }
    } else {
      // Modal closed or no selectedRowDetails
      setBucketFiles([]);
      setSelectedFileUrl(null);
      setIframeError(false);
      setIframeLoading(true);
    }
  }, [detailsModal, selectedRowDetails]);

  // Timeout to detect if iframe fails to load
  useEffect(() => {
    // Clear any existing timeout
    if (iframeLoadTimeoutRef.current) {
      clearTimeout(iframeLoadTimeoutRef.current);
      iframeLoadTimeoutRef.current = null;
    }

    if (selectedFileUrl && iframeLoading) {
      // Set a timeout to detect if iframe doesn't load within 10 seconds
      iframeLoadTimeoutRef.current = setTimeout(() => {
        setIframeError(true);
        setIframeLoading(false);
        iframeLoadTimeoutRef.current = null;
      }, 10000);
    }

    return () => {
      if (iframeLoadTimeoutRef.current) {
        clearTimeout(iframeLoadTimeoutRef.current);
        iframeLoadTimeoutRef.current = null;
      }
    };
  }, [selectedFileUrl, iframeLoading]);

  // Effect to manage body scroll when details modal is open
  useEffect(() => {
    if (detailsModal) {
      document.body.classList.add('details-slider-open');
    } else {
      document.body.classList.remove('details-slider-open');
    }
    return () => {
      document.body.classList.remove('details-slider-open');
    };
  }, [detailsModal]);

  // Add these new state variables
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [tempStartDate, setTempStartDate] = useState(null);
  const [tempEndDate, setTempEndDate] = useState(null);
  const [isRecommendationModal, setIsRecommendationModal] = useState(false);
  const [activeRecommendationTab, setActiveRecommendationTab] = useState('guide');

  // Update tempStartDate and tempEndDate whenever startDate or endDate change
  useEffect(() => {
    if (startDate) {
      setTempStartDate(new Date(startDate));
    }
    if (endDate) {
      setTempEndDate(new Date(endDate));
    }
  }, [startDate, endDate]);

  // Add this new function to format the displayed date range
  const formatDateRange = () => {
    if (startDate && endDate) {
      return `Selected date: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''} to ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    } else if (startDate) {
      return `From: ${startDate ? format(new Date(startDate), 'MM/dd/yyyy') : ''}`;
    } else if (endDate) {
      return `Till: ${endDate ? format(new Date(endDate), 'MM/dd/yyyy') : ''}`;
    }
    return "Select date range"; // Default placeholder text
  };

  // Add this function to handle applying the selected date range
  const applyDateRange = () => {
    if (tempStartDate) {
      setStartDate(format(tempStartDate, 'yyyy-MM-dd'));
    } else {
      setStartDate('');
    }

    if (tempEndDate) {
      setEndDate(format(tempEndDate, 'yyyy-MM-dd'));
    } else {
      setEndDate('');
    }

    setDatePickerOpen(false);
    setPage(1);
  };

  // Update the cancelDateSelection function to clear all dates
  const cancelDateSelection = () => {
    // Clear all date states when cancel is clicked
    setTempStartDate(null);
    setTempEndDate(null);
    setStartDate('');
    setEndDate('');
    setStartDateObj(null);
    setEndDateObj(null);
    setDatePickerOpen(false);
  };


  return (
    <>
      <style>{sliderStyles}</style>
      <div className="container-fluid">
        <AccessPage></AccessPage>
        <div className="block-header">
          <div className="row clearfix">
            <div className="col-md-6 col-sm-12">
              <h1 className="welcome-text">Open Cloud Buckets </h1>
              <nav aria-label="breadcrumb" className="mt-1">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    {vendorId ? <>
                      <Link to="/vendor"
                        onClick={(() => {
                          sessionStorage.clear();
                        })}
                      >Vendor Assessment</Link>
                    </> : <Link to="/" className="welcome-textSmall">Home</Link>}
                  </li>
                  {
                    vendorName ?
                      <li
                        className="breadcrumb-item active"
                        aria-current="page"
                        style={{ color: "white" }}
                      >
                        <Link to={`/dashboard/vendor/${vendorId}`}
                        >{vendorName}</Link>
                      </li> : ''
                  }
                  <li
                    className="breadcrumb-item active"
                    aria-current="page"
                    style={{ color: "white" }}
                  >
                    Open Cloud Buckets
                  </li>
                </ol>
              </nav>
            </div>
            <div className="col-md-6 col-sm-12 hidden-xs d-flex justify-content-end align-items-center">
              <span className="mr-2">
                <a
                  onClick={(e) => {
                    e.preventDefault();
                    setIsRecommendationModal(true);
                  }}
                  href="#"
                  className="btn btn-sm btn-primary mr-1"
                  style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
                >
                  <i className="fa fa-lightbulb-o" style={{ fontSize: "14px" }}></i>
                  Recommendation
                </a>
              </span>


              <span>
                {client?.subscriptionType != "trial" && mapData?.length !== 0 && (
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      downloadFile();
                    }}
                    href="/add-report"
                    className="btn btn-sm btn-primary mr-1 download-report"
                  >
                    Download Details
                  </a>
                )}
              </span>
            </div>
          </div>
        </div>

        <div className="row clearfix">
          <div
            className="col-lg-4 col-md-12 col-sm-12"
            style={{ minHeight: "410px" }}
          >
            <div className="row clearfix">
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="card knowCard">
                  <div className="body">
                    <div className="text-center">
                      <img src={aws} className="img-fluid bucketImg" />
                      <h5 className="m-t-20 mb-4">
                        {totalResponse?.totalAWSCloudBuckets || 0}
                      </h5>
                      <a
                        onClick={() => executeScroll("aws")}
                        style={{ color: "#060606", fontWeight: "bold" }}
                        className="btn btn-round findMoreBtn"
                      >
                        Find more
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="card knowCard">
                  <div className="body">
                    <div className="text-center">
                      <img src={Microsoft} className="img-fluid bucketImg" />
                      <h5 className="m-t-20 mb-4">
                        {totalResponse?.totalAZURECloudBuckets || 0}
                      </h5>
                      <a
                        onClick={() => executeScroll("azure")}
                        style={{ color: "#060606", fontWeight: "bold" }}
                        className="btn btn-round findMoreBtn"
                      >
                        Find more
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="card knowCard">
                  <div className="body">
                    <div className="text-center">
                      <img src={google} className="img-fluid bucketImg" />
                      <h5 className="m-t-20 mb-4">
                        {totalResponse?.totalGCPCloudBuckets || 0}
                      </h5>
                      <a
                        onClick={() => executeScroll("gcp")}
                        style={{ color: "#060606", fontWeight: "bold" }}
                        className="btn btn-round findMoreBtn "
                      >
                        Find more
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-12">
                <div className="card knowCard">
                  <div className="body">
                    <div className="text-center">
                      <img src={cloud} className="img-fluid bucketImg" />
                      <h5 className="m-t-20 mb-4">
                        {totalResponse?.totalDOSCloudBuckets || 0}
                      </h5>
                      <a
                        onClick={() => executeScroll("dos")}
                        style={{ color: "#060606", fontWeight: "bold" }}
                        className="btn btn-round findMoreBtn"
                      >
                        Find more
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12 col-md-12 col-sm-12">
                {client?.subscriptionType == "trial" && (
                  <div className="card border-warning">
                    <TrialComponent />
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-lg-8 col-md-12 col-sm-12">
            <div className="card">
              <div className="body" style={{ minHeight: "410px" }}>
                <h6 className="welcome-textSmall">Previous scan details</h6>
                {oldDnsDetails && (
                  <BasicLineColumn
                    dates={oldDnsDetails?.dates}
                    ipArray={ipArray}
                    color={["#08283f"]}
                    yAxis="Records Found"
                  />
                )}
              </div>
            </div>
          </div>
        </div>
        <ul className="nav nav-tabs mb-2" id="myTabs" role="tablist">
          <li className="nav-item">
            <a
              className={`nav-table-tab nav-link ${category === "all" ? "active" : ""
                }`}
              onClick={() => {
                setCategory("all");
                clearFliter();
              }}
            >
              Current
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link nav-table-tab ${category === "risk-accepted" ? "active" : ""
                }`}
              onClick={() => {
                setCategory("risk-accepted");
                clearFliter();
              }}
            >
              Risk Accepted
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link nav-table-tab ${category === "false-positive" ? "active" : ""
                }`}
              onClick={() => {
                setCategory("false-positive");
                clearFliter();
              }}
            >
              False Positive
            </a>
          </li>
          <li className="nav-item">
            <a
              className={`nav-link nav-table-tab ${category === "remidiated" ? "active" : ""
                }`}
              onClick={() => {
                setCategory("remidiated");
                clearFliter();
              }}
            >
              Remediated
            </a>
          </li>
        </ul>
        <div className="card card_tableBox">
          <div className="body">
            <div className="row" ref={myRef}>
              <div className="col-sm-3 mb-2">
                <select
                  className="custom-select custom-select-sm form-control form-control-sm"
                  onChange={(e) => setfilterData(e.target.value)}
                  value={filterData}
                >
                  <option value="all">Cloud Provider</option>
                  <option value="aws">AWS</option>
                  <option value="dos">DOS</option>
                  <option value="azure">Azure</option>
                  <option value="gcp">GCP</option>
                </select>
              </div>
              <div className="col-sm-3 mb-2">
                <div className="searchBoxInput p-0">
                  <input
                    class="form-control form-control-sm ml-0 my-1"
                    type="text"
                    placeholder="Search"
                    aria-label="Search"
                    value={search}
                    onChange={(e) => {
                      setSearch(e.target.value);
                      setPage(1);
                    }}
                  />
                </div>
              </div>
              <div className="col-sm-2 mb-2">
                <select
                  className="custom-select custom-select-sm form-control form-control-sm"
                  onChange={(e) => {
                    setFileType(e.target.value);
                    setPage(1);
                  }}
                  value={fileType}
                >
                  <option value="all">File Type</option>
                  <option value="pdf">PDF</option>
                  <option value="xlsx">XLSX</option>
                  <option value="xls">XLS</option>
                  <option value="csv">CSV</option>
                  <option value="doc">DOC</option>
                  <option value="docx">DOCX</option>
                  <option value="txt">TXT</option>
                  <option value="rtf">RTF</option>
                  <option value="zip">ZIP</option>
                  <option value="sql">SQL</option>
                  <option value="pem">PEM</option>
                  <option value="json">JSON</option>
                  <option value="xml">XML</option>
                  <option value="env">ENV</option>
                  <option value="config">CONFIG</option>
                  <option value="log">LOG</option>
                  <option value="bak">BAK</option>
                  <option value="jpg">JPG</option>
                  <option value="jpeg">JPEG</option>
                  <option value="png">PNG</option>
                  <option value="gif">GIF</option>
                  <option value="bmp">BMP</option>
                  <option value="svg">SVG</option>
                  <option value="tiff">TIFF</option>
                  <option value="webp">WEBP</option>
                  <option value="ico">ICO</option>
                  <option value="psd">PSD</option>
                </select>
              </div>
              <div className="col-sm-2 mb-2">
                <div className="date-picker-container">
                  <div className="date-range-input">
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      placeholder="Select date range"
                      value={formatDateRange()}
                      onClick={() => setDatePickerOpen(true)}
                      readOnly
                    />
                    <span className="calendar-icon">
                      <i className="fa fa-calendar" aria-hidden="true"></i>
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-sm-2 mb-2">
                <select
                  className="form-control form-control-sm"
                  value={keyword}
                  onChange={(e) => {
                    setKeyword(e.target.value);
                    setPage(1);
                  }}
                >
                  <option value="all">All Keywords</option>
                  {clientKeywords.map((kw, index) => (
                    <option key={index} value={kw}>
                      {kw}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-sm-2 mb-2">
                {selectedIds.length > 1 && userPermission && category === "all" && (
                  <Box sx={{ width: 160 }}>
                    <FormControl fullWidth>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={selectedValue}
                        onChange={(event) => {
                          setAction(event.target.value);
                          snooze("", event.target.value);
                        }}
                      >
                        <MenuItem value="pleaseSelect">Snooze Options</MenuItem>
                        <MenuItem
                          value="riskAccepted"
                          onClick={() => {
                            addModal();
                          }}
                        >
                          Risk Accepted
                        </MenuItem>
                        <MenuItem
                          value="markAsFalsePositive"
                          onClick={() => {
                            addModal();
                          }}
                        >
                          False Positive
                        </MenuItem>
                        <MenuItem value="markAsRemidiated">Remediated</MenuItem>
                      </Select>
                    </FormControl>
                  </Box>
                )}
                {selectedIds.length > 1 && userPermission &&
                  (category == "false-positive" ||
                    category == "risk-accepted") && (
                    <button
                      className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                      onClick={() => Unsnoozed("")}
                    >
                      Unsnooze
                    </button>
                  )}
              </div>
            </div>
            <div className="table-responsive">
              <table className="table table-custom spacing5 mb-0">
                <thead>
                  <tr>
                    {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                      category === "risk-accepted" ||
                      category === "false-positive") && (
                        <th>
                          <input
                            type="checkbox"
                            checked={selectedIds == 0 ? false : multiCheckTrue}
                            onClick={() => multicheck(currentTableData)}
                            className="checkUncheck"
                          />
                        </th>
                      )}
                    <th>Type</th>
                    <th style={{
                      whiteSpace: "normal",
                      wordBreak: "break-word",
                      maxWidth: "200px",
                      minWidth: "150px"
                    }}>Open Cloud Bucket</th>
                    <th style={{
                      whiteSpace: "normal",
                      textAlign: "center",
                      maxWidth: "100px",
                      minWidth: "80px"
                    }}>Risk Score</th>
                    <th>Created At</th>
                    <th>Updated At</th>
                    <th>Details</th>
                    {category !== "all" && <th>Action Note</th>}
                    {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                      category === "risk-accepted" ||
                      category === "false-positive") && (
                        <th>Action</th>
                      )}
                  </tr>
                </thead>
                <tbody>
                  {client?.subscriptionType == "trial" ? (
                    <tr>
                      <td colSpan={7}>
                        <NoData />
                      </td>
                    </tr>
                  ) : (
                    currentTableData?.map((res, index) => {
                      return (
                        <tr key={index}>
                          {auth?.accessLevel != "Threat Analyst" && (category === "all" ||
                            category === "risk-accepted" ||
                            category === "false-positive") && (
                              <td>
                                <input
                                  onClick={() => singleClick(res?._id)}
                                  checked={selectedIds?.includes(res?._id)}
                                  type="checkbox"
                                  className="checkUncheck"
                                />
                              </td>
                            )}
                          <td style={{ verticalAlign: "top" }}>{res.type}</td>
                          <td style={{
                            whiteSpace: "normal",
                            wordBreak: "break-word",
                            overflowWrap: "break-word",
                            maxWidth: "200px",
                            minWidth: "150px",
                            verticalAlign: "top",
                            padding: "8px",
                            lineHeight: "1.5"
                          }}>
                            <div style={{
                              wordBreak: "break-word",
                              overflowWrap: "break-word",
                              marginBottom: "4px"
                            }}>
                              {res.source || res.bucket || "N/A"}
                            </div>
                            {(res.email || res.fullPath) && (
                              <small className="text-muted" style={{
                                wordBreak: "break-word",
                                overflowWrap: "break-word",
                                display: "block"
                              }}>
                                {res.email || res.fullPath}
                              </small>
                            )}
                          </td>
                          <td style={{
                            textAlign: "center",
                            verticalAlign: "middle",
                            maxWidth: "100px",
                            minWidth: "80px",
                            padding: "8px"
                          }}>
                            <span className={`badge ${res.risk_score >= 7 ? 'badge-danger' : res.risk_score >= 4 ? 'badge-warning' : 'badge-success'}`}>
                              {res.risk_score || 'N/A'}
                            </span>
                          </td>
                          <td>{moment(res.createdAt).format("DD-MM-YYYY")}</td>
                          <td>{moment(res.updatedAt).format("DD-MM-YYYY")}</td>
                          <td>
                            <button
                              className="btn btn-sm"
                              onClick={() => {
                                setSelectedRowDetails(res);
                                setDetailsModal(true);
                              }}
                              style={{
                                backgroundColor: "#17a2b8",
                                borderColor: "#17a2b8",
                                color: "#fff",
                                borderRadius: "4px",
                                padding: "4px 12px",
                                transition: "all 0.3s ease",
                                display: "inline-flex",
                                alignItems: "center",
                                gap: "6px"
                              }}
                              onMouseEnter={(e) => {
                                e.target.style.backgroundColor = "#138496";
                                e.target.style.borderColor = "#117a8b";
                                e.target.style.transform = "translateY(-1px)";
                                e.target.style.boxShadow = "0 2px 4px rgba(0,0,0,0.2)";
                              }}
                              onMouseLeave={(e) => {
                                e.target.style.backgroundColor = "#17a2b8";
                                e.target.style.borderColor = "#17a2b8";
                                e.target.style.transform = "translateY(0)";
                                e.target.style.boxShadow = "none";
                              }}
                            >
                              <i className="fa fa-info-circle" style={{ fontSize: "14px" }}></i>
                              <span>Details</span>
                            </button>
                          </td>
                          {category !== "all" && <td style={{ whiteSpace: "unset" }}>{res?.actionNote ? res.actionNote : "N/A"}</td>}
                          {auth?.accessLevel != "Threat Analyst" && userPermission && category === "all" && (
                            <td>
                              <Box sx={{ width: 160 }}>
                                <FormControl fullWidth>
                                  <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={selectedValue}
                                    onChange={(event) => {
                                      setAction(event.target.value);
                                      snooze(res?._id, event.target.value);
                                    }}
                                  >
                                    <MenuItem value="pleaseSelect">
                                      Snooze Options
                                    </MenuItem>
                                    <MenuItem
                                      value="riskAccepted"
                                      onClick={() => {
                                        addModal();
                                        setLookalikeAppId([res._id]);
                                      }}
                                    >
                                      Risk Accepted
                                    </MenuItem>
                                    <MenuItem
                                      value="markAsFalsePositive"
                                      onClick={() => {
                                        addModal();
                                        setLookalikeAppId([res._id]);
                                      }}
                                    >
                                      False Positive
                                    </MenuItem>
                                    <MenuItem value="markAsRemidiated">
                                      Remediated
                                    </MenuItem>
                                  </Select>
                                </FormControl>
                              </Box>
                            </td>
                          )}
                          {auth?.accessLevel != "Threat Analyst" && userPermission && (category === "risk-accepted" || category === "false-positive") && (
                            <td>
                              <button
                                className="btn btn-primary btn-sm mr-1 Unsnooze mb-2"
                                onClick={() => Unsnoozed(res?._id)}
                              >
                                Unsnooze
                              </button>
                            </td>
                          )}
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-between align-content-center">
              <div className="dataTables_paginate">
                {totalItems > 0 && (
                  <Pagination
                    className="pagination-bar"
                    currentPage={page}
                    totalCount={totalItems}
                    pageSize={limit}
                    onPageChange={(page) => setPage(page)}
                  />
                )}
              </div>
              {totalItems > 10 && (
                <select
                  value={limit}
                  onChange={(e) => {
                    setLimit(e.target.value)
                  }}
                  className="form-control limitSelectBox"
                >
                  <option value={10}>10 per page</option>
                  <option value={25}>25 per page</option>
                  <option value={50}>50 per page</option>
                  <option value={100}>100 per page</option>
                </select>
              )}
            </div>
          </div>
        </div>
        {datePickerOpen && (
          <div className="date-range-overlay" onClick={() => setDatePickerOpen(false)}>
            <div className="date-range-picker-popup" onClick={(e) => e.stopPropagation()}>
              <div className="date-range-picker-header">
                {tempStartDate && tempEndDate
                  ? `Selected date: ${format(tempStartDate, 'MM/dd/yyyy')} to ${format(tempEndDate, 'MM/dd/yyyy')}`
                  : "Select date range"}
              </div>
              <div className="date-range-calendars">
                <div>
                  <h6>From</h6>
                  <DatePicker
                    selected={tempStartDate}
                    onChange={(date) => {
                      setTempStartDate(date);
                      if (tempEndDate && date > tempEndDate) {
                        setTempEndDate(null);
                      }
                    }}
                    selectsStart
                    startDate={tempStartDate}
                    endDate={tempEndDate}
                    inline
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                </div>
                <div>
                  <h6>To</h6>
                  <DatePicker
                    selected={tempEndDate}
                    onChange={(date) => setTempEndDate(date)}
                    selectsEnd
                    startDate={tempStartDate}
                    endDate={tempEndDate}
                    minDate={tempStartDate}
                    inline
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode="select"
                  />
                </div>
              </div>
              <div className="date-range-actions">
                <button
                  className="date-range-apply"
                  onClick={applyDateRange}
                >
                  Apply Filter
                </button>
                <button
                  className="date-range-cancel"
                  onClick={cancelDateSelection}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
        <div
          className={`modal fade Form-Wizard-modal ${isModal === "Form Wizard modal" ? "d-block show" : ""
            }`}
        >
          <div className="modal-dialog modal-lg" id="clientModal">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="exampleModalLabel">
                  {action == "markAsFalsePositive"
                    ? "Mark As False Positive"
                    : "Risk Accepted"}
                </h5>
                <button
                  type="button"
                  data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModal("");
                    setActionNote("");
                  }}
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body pricing_page modal_mob">
                <div className="col-xl-12 col-lg-12 col-md-12">
                  <div className="card">
                    <div className="row clearfix">
                      <div className="col-md-12">
                        <label className="col-lg-6 col-md-12">Snooze for</label>
                        <div className="form-group ol-lg-12 col-md-12">
                          <select
                            className="custom-select custom-select-sm form-control form-control-sm"
                            onChange={(e) => setForValue(e.target.value)}
                          >
                            <option value="forever">Forever</option>
                            <option value="3 months">3 Months</option>
                            <option value="6 months">6 Months</option>
                            <option value="12 months">12 Months</option>
                          </select>
                        </div>
                      </div>
                      <div className="col-md-12">
                        <label className="col-lg-12 col-md-12">Detail</label>
                        <div className="form-group col-lg-12 col-md-12">
                          <textarea
                            onChange={(e) => setActionNote(e.target.value)}
                            value={actionNote}
                            className="form-control"
                            rows="3"
                          ></textarea>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div
                        className="col-lg-12 col-md-12"
                        style={{ marginRight: "28px" }}
                      >
                        <button
                          type="button"
                          style={{ color: "black", fontWeight: "bold" }}
                          onClick={submit}
                          className="btn btn-round btn-primary mr-1 pull-right"
                        >
                          Submit
                        </button>
                        &nbsp;&nbsp;
                        <button
                          type="button"
                          onClick={() => {
                            setModal("");
                            setActionNote("");
                          }}
                          className="btn btn-round btn-default pull-right"
                          style={{ marginRight: "10px" }}
                        >
                          Cancel
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Details Slider */}
      <div
        className={`details-slider-overlay ${detailsModal ? "show" : ""}`}
        onClick={() => {
          setDetailsModal(false);
          setSelectedRowDetails(null);
        }}
      ></div>
      <div className={`details-slider-panel ${detailsModal ? "open" : ""}`}>
        <div className="details-slider-content">
          <div className="details-slider-header">
            <h5 style={{ color: "white", margin: 0 }}>
              <i className="fa fa-cloud mr-2"></i>
              Cloud Bucket Details
              {selectedRowDetails?._id && (
                <span className="ml-2" style={{ fontSize: "0.85em", opacity: 0.9, color: "white" }}>
                  - {selectedRowDetails._id.substring(0, 20)}...
                </span>
              )}
            </h5>
            <button
              type="button"
              className="details-slider-close"
              onClick={() => {
                setDetailsModal(false);
                setSelectedRowDetails(null);
              }}
              aria-label="Close"
            >
              <i className="fa fa-times"></i>
            </button>
          </div>
          <div className="details-slider-body">
            {selectedRowDetails && (
              <>
                {/* Risk Assessment Section */}
                <div className="details-section">
                  <div className="details-section-title">
                    <i className="fa fa-shield-alt"></i>
                    Risk Assessment
                  </div>
                  <div className="details-info-item">
                    <span className="details-info-label">Risk Score:</span>
                    <span className="details-info-value">
                      <span className={`badge ${selectedRowDetails.risk_score >= 7 ? 'badge-danger' : selectedRowDetails.risk_score >= 4 ? 'badge-warning' : 'badge-success'}`}>
                        {selectedRowDetails.risk_score || 'N/A'}
                      </span>
                    </span>
                  </div>
                </div>

                {/* Basic Information Section */}
                <div className="details-section">
                  <div className="details-section-title">
                    <i className="fa fa-info-circle"></i>
                    Basic Information
                  </div>
                  <div className="details-info-item">
                    <span className="details-info-label">Bucket Name:</span>
                    <span className="details-info-value">{selectedRowDetails.email || selectedRowDetails.username || selectedRowDetails.bucket || "N/A"}</span>
                  </div>
                  <div className="details-info-item">
                    <span className="details-info-label">Source:</span>
                    <span className="details-info-value">{selectedRowDetails.source || selectedRowDetails.fullPath || "N/A"}</span>
                  </div>
                  <div className="details-info-item">
                    <span className="details-info-label">Type:</span>
                    <span className="details-info-value">{selectedRowDetails.type || "N/A"}</span>
                  </div>
                  <div className="details-info-item">
                    <span className="details-info-label">Exposure Type:</span>
                    <span className="details-info-value">{selectedRowDetails.exposure_type || selectedRowDetails.type || "N/A"}</span>
                  </div>
                  <div className="details-info-item">
                    <span className="details-info-label">Created At:</span>
                    <span className="details-info-value">{selectedRowDetails.createdAt ? moment(selectedRowDetails.createdAt).format('DD-MM-YYYY') : "N/A"}</span>
                  </div>
                  <div className="details-info-item">
                    <span className="details-info-label">Updated At:</span>
                    <span className="details-info-value">{selectedRowDetails.updatedAt ? moment(selectedRowDetails.updatedAt).format('DD-MM-YYYY') : "N/A"}</span>
                  </div>
                  {selectedRowDetails.analysis_timestamp && (
                    <div className="details-info-item">
                      <span className="details-info-label">Analysis Date:</span>
                      <span className="details-info-value">{moment(selectedRowDetails.analysis_timestamp).format('DD-MM-YYYY HH:mm:ss')}</span>
                    </div>
                  )}
                </div>

                {/* Public Links Section */}
                {(selectedRowDetails.url || selectedRowDetails.bucket) && (
                  <div className="details-section">
                    <div className="details-section-title">
                      <i className="fa fa-link"></i>
                      Public Links
                    </div>
                    {selectedRowDetails.url && (
                      <div className="public-link-item">
                        <span className="public-link-url">{selectedRowDetails.url}</span>
                        <button
                          className="public-link-button"
                          onClick={() => handleOpenUrl(selectedRowDetails.url)}
                          title="Open in new tab"
                        >
                          <i className="fa fa-external-link mr-1"></i>
                          Open
                        </button>
                      </div>
                    )}

                  </div>
                )}

                {/* Exposed Files Section */}
                {selectedRowDetails?.url && (
                  <div className="details-section">
                    <div className="details-section-title">
                      <i className="fa fa-file"></i>
                      Exposed Files
                    </div>
                    <div>
                      {/* File URL */}
                      <div style={{ marginBottom: "15px" }}>
                        <div
                          className="public-link-item"
                          style={{
                            cursor: selectedRowDetails.url ? "pointer" : "default",
                            backgroundColor: selectedFileUrl === selectedRowDetails.url ? "#e7f3ff" : "#f8f9fa",
                            borderColor: selectedFileUrl === selectedRowDetails.url ? "#453acd" : "#dee2e6"
                          }}
                          onClick={() => {
                            if (selectedRowDetails.url) {
                              setSelectedFileUrl(selectedRowDetails.url);
                              setIframeLoading(true);
                              setIframeError(false);
                            }
                          }}
                        >
                          <div style={{ flex: 1, display: "flex", flexDirection: "column", gap: "4px" }}>
                            <span className="public-link-url" style={{ fontWeight: "500", color: "#212529" }}>
                              {selectedRowDetails.filename || selectedRowDetails.url.split('/').pop() || 'File'}
                            </span>
                            {selectedRowDetails.size && (
                              <small style={{ color: "#6c757d", fontSize: "0.8rem" }}>
                                Size: {typeof selectedRowDetails.size === 'number' ? `${(selectedRowDetails.size / 1024).toFixed(2)} KB` : selectedRowDetails.size}
                              </small>
                            )}
                            {selectedRowDetails.fullPath && (
                              <small style={{ color: "#6c757d", fontSize: "0.8rem", wordBreak: "break-all" }}>
                                Path: {selectedRowDetails.fullPath}
                              </small>
                            )}
                            <small style={{ color: "#453acd", fontSize: "0.8rem", wordBreak: "break-all" }}>
                              {selectedRowDetails.url}
                            </small>
                          </div>
                          {selectedRowDetails.url && (
                            <div style={{ display: "flex", gap: "5px" }}>
                              <button
                                className="public-link-button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setSelectedFileUrl(selectedRowDetails.url);
                                  setIframeLoading(true);
                                  setIframeError(false);
                                }}
                                title="View in iframe"
                                style={{
                                  backgroundColor: selectedFileUrl === selectedRowDetails.url ? "#3829b8" : "#453acd",
                                  fontSize: "0.8rem",
                                  padding: "6px 10px"
                                }}
                              >
                                <i className="fa fa-eye mr-1"></i>
                                View
                              </button>
                              <button
                                className="public-link-button"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleOpenUrl(selectedRowDetails.url);
                                }}
                                title="Open file URL in new tab"
                                style={{
                                  backgroundColor: "#17a2b8",
                                  fontSize: "0.8rem",
                                  padding: "6px 10px"
                                }}
                              >
                                <i className="fa fa-external-link mr-1"></i>
                                Open
                              </button>
                            </div>
                          )}
                        </div>
                      </div>

                      {/* File Preview Iframe */}
                      {(selectedFileUrl || selectedRowDetails?.url) && (
                        <div style={{
                          border: "1px solid #dee2e6",
                          borderRadius: "4px",
                          overflow: "hidden",
                          marginTop: "15px",
                          position: "relative"
                        }}>
                          <div style={{
                            background: "#f8f9fa",
                            padding: "8px 12px",
                            borderBottom: "1px solid #dee2e6",
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center"
                          }}>
                            <span style={{ fontSize: "0.85rem", color: "#495057", wordBreak: "break-all" }}>
                              <i className="fa fa-file mr-2"></i>
                              {selectedFileUrl || selectedRowDetails?.url}
                            </span>
                            <button
                              onClick={() => {
                                setSelectedFileUrl(null);
                                setIframeError(false);
                                setIframeLoading(true);
                              }}
                              style={{
                                background: "none",
                                border: "none",
                                color: "#6c757d",
                                cursor: "pointer",
                                fontSize: "16px",
                                padding: "0 5px"
                              }}
                              title="Close preview"
                            >
                              <i className="fa fa-times"></i>
                            </button>
                          </div>
                          {iframeLoading && !iframeError && (
                            <div style={{
                              width: "100%",
                              height: "600px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "#f8f9fa",
                              flexDirection: "column",
                              gap: "10px"
                            }}>
                              <i className="fa fa-spinner fa-spin" style={{ fontSize: "24px", color: "#453acd" }}></i>
                              <span style={{ color: "#6c757d" }}>Loading file preview...</span>
                            </div>
                          )}
                          {iframeError && (
                            <div style={{
                              width: "100%",
                              height: "600px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              backgroundColor: "#f8f9fa",
                              flexDirection: "column",
                              gap: "15px",
                              padding: "20px"
                            }}>
                              <i className="fa fa-exclamation-triangle" style={{ fontSize: "48px", color: "#ffc107" }}></i>
                              <div style={{ textAlign: "center" }}>
                                <h6 style={{ color: "#495057", marginBottom: "10px" }}>Unable to display file in preview</h6>
                                <p style={{ color: "#6c757d", fontSize: "0.9rem", marginBottom: "15px" }}>
                                  This file cannot be embedded due to CORS (Cross-Origin Resource Sharing) restrictions.
                                  The S3 bucket needs to be configured with proper CORS headers to allow embedding.
                                  Click below to open the file in a new tab instead.
                                </p>
                                <button
                                  className="public-link-button"
                                  onClick={() => handleOpenUrl(selectedFileUrl || selectedRowDetails?.url)}
                                  style={{
                                    backgroundColor: "#453acd",
                                    padding: "8px 16px",
                                    fontSize: "0.9rem"
                                  }}
                                >
                                  <i className="fa fa-external-link mr-2"></i>
                                  Open in New Tab
                                </button>
                              </div>
                            </div>
                          )}
                          {/* Try iframe first, fallback to embed/object for cross-origin PDFs */}
                          {(() => {
                            const fileUrl = selectedFileUrl || selectedRowDetails?.url;
                            const isS3Url = fileUrl && (fileUrl.includes('s3.amazonaws.com') || fileUrl.includes('amazonaws.com'));

                            // For S3 URLs, use embed tag which handles CORS better
                            if (isS3Url && fileUrl.toLowerCase().endsWith('.pdf')) {
                              return (
                                <embed
                                  src={fileUrl}
                                  type="application/pdf"
                                  style={{
                                    width: "100%",
                                    height: "600px",
                                    border: "none",
                                    display: iframeError ? "none" : "block",
                                    backgroundColor: "#f8f9fa"
                                  }}
                                  onLoad={() => {
                                    setIframeLoading(false);
                                    setIframeError(false);
                                  }}
                                  onError={() => {
                                    setIframeLoading(false);
                                    setIframeError(true);
                                  }}
                                />
                              );
                            }

                            // For other URLs, use iframe with relaxed sandbox
                            return (
                              <iframe
                                src={fileUrl}
                                style={{
                                  width: "100%",
                                  height: "600px",
                                  border: "none",
                                  display: iframeError ? "none" : "block",
                                  backgroundColor: "#f8f9fa"
                                }}
                                title="File Preview"
                                allow="fullscreen"
                                sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-top-navigation"
                                onLoad={() => {
                                  if (iframeLoadTimeoutRef.current) {
                                    clearTimeout(iframeLoadTimeoutRef.current);
                                    iframeLoadTimeoutRef.current = null;
                                  }
                                  setIframeLoading(false);
                                  setIframeError(false);
                                }}
                                onError={() => {
                                  setIframeLoading(false);
                                  setIframeError(true);
                                }}
                              />
                            );
                          })()}
                        </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Associated Data Found Section */}
                {selectedRowDetails.pii_entities && selectedRowDetails.pii_entities.length > 0 && (
                  <div className="details-section">
                    <div className="details-section-title">
                      <i className="fa fa-database"></i>
                      Associated Data Found
                    </div>
                    <div style={{ display: "flex", flexWrap: "wrap", gap: "8px" }}>
                      {selectedRowDetails.pii_entities.map((entity, index) => (
                        <span key={index} className="badge badge-info">
                          {typeof entity === 'string' ? entity :
                            <>
                              {entity.entity}
                              {entity.confidence &&
                                <small className="ml-1">({Math.round(entity.confidence * 100)}%)</small>
                              }
                            </>
                          }
                        </span>
                      ))}
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      {/* Recommendation Modal */}
      {isRecommendationModal && (
        <div className="recommendation-modal-overlay" onClick={() => setIsRecommendationModal(false)}>
          <div className="recommendation-modal-container" onClick={(e) => e.stopPropagation()}>
            <button className="recommendation-modal-close" onClick={() => setIsRecommendationModal(false)}>
              &times;
            </button>

            <div className="recommendation-modal-content">
              <div className="recommendation-tabs">
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'guide' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('guide')}
                >
                  Guidance
                </button>
                <button
                  className={`recommendation-tab ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}
                  onClick={() => setActiveRecommendationTab('checklist')}
                >
                  Action Checklist
                </button>
              </div>

              {/* GUIDANCE TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'guide' ? 'active' : ''}`}>
                <div className="guide-intro">
                  BrandSek continuously monitors cloud storage buckets across AWS S3, Google Cloud Storage, and Azure Blob Storage for misconfigured public access permissions that expose sensitive data.
                </div>

                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>What Are Open Cloud Buckets</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Open cloud buckets are storage containers on cloud platforms (AWS, GCP, Azure) that have been inadvertently configured with public read or write access, exposing their contents to the internet.
                    </p>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>What BrandSek Detects</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>AWS S3 buckets with public read/write permissions</li>
                      <li>Google Cloud Storage buckets with AllUsers access</li>
                      <li>Azure Blob containers with public blob or container access</li>
                      <li>Exposed backup files, configuration files, and PII</li>
                      <li>Credentials, API keys, and tokens stored in buckets</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Why Open Buckets Are High Risk</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Unintended public exposure of sensitive corporate or customer data</li>
                      <li>Credential leaks enabling further system compromise</li>
                      <li>Intellectual property theft and competitive intelligence exposure</li>
                      <li>Compliance violations (GDPR, DPDPA, PCI-DSS)</li>
                      <li>Reputational damage and customer trust erosion</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Common Abuse Scenarios</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Data exfiltration for ransom or competitive intelligence</li>
                      <li>Credential harvesting for lateral movement</li>
                      <li>Malware hosting using exposed writeable buckets</li>
                      <li>Reconnaissance for targeted attacks</li>
                      <li>Compliance violations leading to regulatory fines</li>
                    </ul>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Governance & Compliance Impact</h3>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <p>
                      Exposed cloud storage may violate GDPR (Article 32), DPDPA security obligations, PCI-DSS Requirement 3, and RBI cybersecurity framework controls. ISO 27001 requires secure cloud configurations (A.14.1.2). Immediate remediation and breach assessment are critical.
                    </p>
                  </div>
                </details>
              </div>

              {/* CHECKLIST TAB */}
              <div className={`recommendation-tab-content ${activeRecommendationTab === 'checklist' ? 'active' : ''}`}>
                <details className="checklist-details" open>
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Immediate Access Restriction</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Revoke public access permissions immediately</li>
                      <li>Implement bucket-level access control lists (ACLs)</li>
                      <li>Enable bucket versioning to track changes</li>
                      <li>Apply least-privilege IAM policies</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.9.4.1 · PCI-DSS 7.1</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Exposure Validation & Impact Assessment</h3>
                      <span className="severity-badge high">High</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Review bucket access logs for unauthorized access</li>
                      <li>Identify data types exposed (PII, credentials, IP)</li>
                      <li>Determine exposure duration from configuration history</li>
                      <li>Assess regulatory notification obligations (GDPR, DPDPA)</li>
                    </ul>
                    <div className="compliance-tag">GDPR Article 33 · DPDPA Breach Notification</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Data Cleanup & Containment</h3>
                      <span className="severity-badge medium">Medium</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Rotate exposed credentials, API keys, and secrets</li>
                      <li>Remove or encrypt sensitive data in buckets</li>
                      <li>Enable server-side encryption (SSE-S3, SSE-KMS)</li>
                      <li>Review and remediate similar exposures across cloud accounts</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.10.1.2 · PCI-DSS 3.4</div>
                  </div>
                </details>

                <details className="checklist-details">
                  <summary className="checklist-summary">
                    <div className="summary-left">
                      <h3>Monitoring & Governance</h3>
                      <span className="severity-badge low">Low</span>
                    </div>
                  </summary>
                  <div className="checklist-card-content">
                    <ul className="checklist-items">
                      <li>Enable CloudTrail/Cloud Audit Logs for bucket activity</li>
                      <li>Implement automated bucket policy compliance checks</li>
                      <li>Establish secure cloud configuration baselines</li>
                      <li>Conduct cloud security training for DevOps teams</li>
                    </ul>
                    <div className="compliance-tag">ISO 27001 A.12.4.1 · CIS AWS Benchmark</div>
                  </div>
                </details>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default SourceCodeLeakage;
